import { Component, ChangeDetectionStrategy, OnDestroy, inject } from '@angular/core';
import { environment } from '@env/environment';
import { TranslateService, TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-menu-languages',
    templateUrl: './menu-languages.component.html',
    styleUrls: ['./menu-languages.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateDirective, TranslatePipe],
})
export class MenuLanguagesComponent implements OnDestroy {
    private translationService = inject(TranslateService);

    private subscriptions = new Subscription();

    appUrl = environment.appUrl;

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Get all available languages
     */
    get languages(): string[] {
        return environment.supportedLanguages;
    }

    /**
     * Current Lang
     */
    get currentLang(): string {
        return this.translationService.currentLang;
    }
}
